export const fetcher = (params) => {
  if (typeof params === 'string' ) return fetch(params).then(res => res.json());

  const [URL, config] = params;

  return fetch(URL, config).then(res => res.json());
};